import i18n from 'i18n'

const DC3_LOCALE_PATHS = ['en', 'es', 'fr', 'pt'] as const

interface TranslationFile {
  dc3Certificate?: Record<string, unknown>
}

let loaded = false

/**
 * Prioriza traducciones locales del PDF DC-3 sobre el host remoto.
 * Se cargan vía fetch desde /public/locales (CRA no permite importar fuera de src/).
 */
export const ensureLocalDc3CertificateTranslations = async () => {
  if (loaded) return

  await Promise.all(
    DC3_LOCALE_PATHS.map(async (lang) => {
      try {
        const response = await fetch(`/locales/${lang}/translation.json`)
        if (!response.ok) return

        const data = (await response.json()) as TranslationFile
        if (!data.dc3Certificate) return

        i18n.addResourceBundle(
          lang,
          'lms',
          { dc3Certificate: data.dc3Certificate },
          true,
          true
        )
      } catch {
        // Sin traducciones locales: se usa el host remoto.
      }
    })
  )

  loaded = true
}
